"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_TYPE = void 0;
var PRODUCT_TYPE = {
  CAST: 'CAST',
  PRO: 'PRO',
  ELEVATE: 'ELEVATE',
  // we don't have ELEVATE in the Video.product enum, but we have PITCH. So this might better to be remove in future. See packages/common-models-schemas/constants/videoProduct.js
  PITCH: 'PITCH',
  // for pitch (elevate) videos
  PITCHTEMPLATE: 'PITCHTEMPLATE' // for pitch (elevate) templates

};
exports.PRODUCT_TYPE = PRODUCT_TYPE;